import React, { useState } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'
import { Outlet } from 'react-router-dom'

const Dashboard = () => {
    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarHidden(prev => !prev);
    };
    return (
        <>
            <Sidebar isHidden={isSidebarHidden} />
            <Header onToggleSidebar={toggleSidebar} />
            <Outlet />
            <Footer />
        </>
    )
}

export default Dashboard